module.exports = __webpack_public_path__ + "static/media/home_mobile_min.262349ea.jpg";